import { maxBy } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import CategoryRadarSection from './shared/CategoryRadarSection';
import type { ML360Statistic } from './shared/utils';

interface ML360ResultProps {
    statistics: ML360Statistic[];
    summaryFormation?: number[];
}

const ML360Result = ({ statistics, summaryFormation = [2, 2, 1] }: ML360ResultProps) => {
    const { t } = useTranslation('assessmentResultManagementPage');
    const domain = useMemo(() => maxBy(statistics, 'total')?.total || 0, [statistics]);

    const radarData = useMemo(
        () =>
            statistics.map(s => ({
                shortLabel: s.shortLabel,
                value: s.value,
            })),
        [statistics]
    );

    const summaryCards = useMemo(
        () =>
            statistics.map(s => ({
                label: s.label,
                value: s.value,
                total: s.total,
            })),
        [statistics]
    );

    return (
        <CategoryRadarSection
            statistics={{
                domainMax: domain,
                radarData,
                summaryCards,
                tickCount: 8,
            }}
            summaryFormation={summaryFormation}
            summaryValueDecimals={1}
            tooltipValueLabel={t('details.ml360.yourScore')}
            tooltipAxisLabel={t('details.ml360.category')}
        />
    );
};

export default ML360Result;
